/**
 * Hover styles for devices that can actually hover. On touch screens a plain
 * `:hover` sticks to the last tapped element until something else is tapped.
 *
 *   sx={{ ...hoverOnly({ bgcolor: colors.card }) }}
 */
export const hoverOnly = (styles) => ({
  '@media (hover: hover)': {
    '&:hover': styles,
  },
});
